import { CONTROL_PANEL_URL } from '../../utils/constants';

export const NODE_SAFENAME = 'nodejs';

export const MONGO_SAFENAME = 'mongodb';

export const LEARN_MORE_URL =
  'https://www.digitalocean.com/blog/introducing-digitalocean-managed-mongodb/';

export const TRY_IT_URL = `${CONTROL_PANEL_URL}/droplets/new?size=s-4vcpu-8gb-intel&region=nyc1&appId=121155561&image=nodejs-20-04&type=applications&mp_source=banner&engine=mongodb`;

export const NODE_MONGO_BANNER_EXPERIMENT_NAME =
  'mp-3509_add_node_mongodb_integration_banner';

export enum NODE_MONGO_BANNER_EXPERIMENT_VARIANTS {
  CONTROL = 'Control',
  TREATMENT = 'Treatment'
}
